var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconSynchronizeArrows1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("title", null, "synchronize-arrows-1"), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.362,7A8.25,8.25,0,0,0,3.75,12.247V14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,17.908A8.25,8.25,0,0,0,20.25,12.247v-1.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "0.75 11.497 3.75 14.497 6.75 11.497"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "23.25 13.747 20.25 10.747 17.25 13.747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconSynchronizeArrows1);
export default __webpack_public_path__ + "static/media/streamline-icon-synchronize-arrows-1.1644cc58.svg";
export { ForwardRef as ReactComponent };